import Vue from 'vue';
import Element from 'element-ui';
import App from './App.vue';
import router from './router';
import Storage from 'vue-ls'
import VueClipboard from 'vue-clipboard2'
import TableQgm from '@qtt/wlx-element-ui/lib/table-qgm';
import TableColumnQgm from '@qtt/wlx-element-ui/lib/table-column';
import 'element-ui/lib/theme-chalk/index.css';
import '@qtt/wlx-element-ui/lib/theme-chalk/index.css';

import 'element-ui/lib/theme-chalk/index.css';
// import '@qtt/wlx-element-ui/lib/theme-chalk/index.css';


// 接入版本更新提醒 
import SimpleUpdateDetector from '@qtt/web-update-checker';
import { MessageBox } from 'element-ui';
new SimpleUpdateDetector({
	// checkInterval: 5 * 60 * 1000, // 默认5分钟
	onUpdate: (version, oldVersion, tmUpdate) => {
		console.log(`新版本: ${version},  旧版本: ${oldVersion},  最后更新时间: ${tmUpdate}`);
		MessageBox.confirm(
			`发现新版本(${version})，是否立即刷新页面`,
			'版本更新提醒',
			{
				confirmButtonText: '立即刷新',
				cancelButtonText: '稍后再说',
				type: 'warning'
			}
		).then(() => {
			// 强制刷新
			const url = new window.URL(window.location.href);
			url.searchParams.set('_update', String(Date.now()));
			window.location.href = url.toString();

			// 普通刷新
			// window.location.reload();
		}).catch(() => {});
	}
}).init();


const options = {
  namespace: 'qumeng__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', //storage name session, local, memory
}

Vue.config.productionTip = false;

Vue.use(Element, { size: 'middle' });
Vue.use(Storage, options);
Vue.use(VueClipboard);
Vue.use(TableQgm);
Vue.use(TableColumnQgm);

// Object.keys(directives).forEach((name) => {
//   Vue.directive(name, directives[name]);
// });

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
